@import '~less/global-variables';
@import '~less/layout/typography';

.page-header {
  display: block;
  font-size: 48px;
  line-height: 48px;
  .font-brand-regular();
  margin-bottom: 50px;
  position: relative;
  text-align: center;
  text-shadow: 4px 4px 0 rgba(0, 0, 0, 0.07);
  text-transform: uppercase;
  border: 0;
  margin-bottom: 0;
  &:before {
    border: 1px solid @brand-secondary;
    border-width: 1px 0;
    content: '';
    display: block;
    height: 4px;
    left: 0;
    margin-top: -2px;
    position: absolute;
    top: 50%;
    width: 100%;
    z-index: 1;
  }
  h1,
  h2 {
    background-color: @body-bg;
    display: inline-block;
    padding: 0 18px;
    position: relative;
    z-index: 2;
  }
  &.page-header-first {
    margin-top: 0;
  }
  @media (max-width: @screen-xs-max) {
    &,
    h2 {
      font-size: 23px;
    }
  }
}
